import {
  Box,
  Grid,
  Typography,
  IconButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { useEffect, useState } from "react";
import configServ from "../../services/config";
import CircularProgress from "@mui/material/CircularProgress";
import ImageZoomDialog from "../AlertDialog/ImageZoomDialog";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
const ReportSection = ({ userId, itemId }) => {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("Please select user and pain area.");

  const [imageDialogOpen, setImageDialogOpen] = useState(false);
  const [selectedImageUrl, setSelectedImageUrl] = useState("");
  const [isExpanded, setIsExpanded] = useState(false);
  useEffect(() => {
    const fetchReports = async () => {
      if (!userId || !itemId) {
        setReports([]);
        setMessage("Please select user and pain area.");
        return;
      }

      setLoading(true);
      try {
        const dataToSend = {
          user_id: userId,
          item_id: itemId,
        };

        const res = await configServ.getReportsByUserIdAndItemId(dataToSend);

        if (res.success && res.reports?.length > 0) {
          setReports(res.reports);
          setMessage("");
        } else {
          setReports([]);
          setMessage("No report data available.");
        }
      } catch (error) {
        console.error("Error fetching reports:", error);
        setReports([]);
        setMessage("Failed to fetch report data.");
      } finally {
        setLoading(false);
      }
    };

    fetchReports();
  }, [userId, itemId]);

  const openPDF = (base64) => {
    const win = window.open();
    win.document.write(
      `<iframe src="${base64}" width="100%" height="100%" frameborder="0"></iframe>`
    );
  };

  return (
    <Box sx={{ mt: 2, mb: 3 }}>
      <ImageZoomDialog
        open={imageDialogOpen}
        onClose={() => setImageDialogOpen(false)}
        imageUrl={selectedImageUrl}
      />

      <Typography variant="h6" gutterBottom>
        Lab Reports
      </Typography>

      {loading ? (
        <Box display="flex" justifyContent="center" mt={2} mb={5}>
          <CircularProgress />
        </Box>
      ) : message ? (
        <Box display="flex" justifyContent="center" mt={2} mb={5}>
          <Typography color="error">{message}</Typography>
        </Box>
      ) : (
        <Accordion
          expanded={isExpanded}
          onChange={() => setIsExpanded(!isExpanded)}
          sx={{
            backgroundColor: "white",
            borderRadius: 2,
            transition: "width 0.3s ease",
            width: isExpanded ? "100%" : { xs: "100%", sm: "100%", md: "50%" },
            // mx: "auto", // center align
            ml: 0,
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6" color="primary">
              Uploaded Reports
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={2}>
              {reports.map((report) => (
                <Grid item xs={12} sm={6} md={4} key={report.id}>
                  <Box
                    sx={{
                      backgroundColor: "white",
                      p: 2,
                      borderRadius: 2,
                      boxShadow: 1,
                    }}
                  >
                    <Typography variant="subtitle2" fontWeight="bold">
                      {report.reportName || "No Title"}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      sx={{ mb: 1 }}
                    >
                      {report.description || "No Description"}
                    </Typography>

                    {report.file_base64?.startsWith("data:application/pdf") ? (
                      <IconButton onClick={() => openPDF(report.file_base64)}>
                        <PictureAsPdfIcon sx={{ fontSize: 32, color: "red" }} />
                      </IconButton>
                    ) : report.file_base64 ? (
                      <img
                        src={report.file_base64}
                        onClick={() => {
                          setSelectedImageUrl(report.file_base64);
                          setImageDialogOpen(true);
                        }}
                        alt="report"
                        style={{
                          width: 60,
                          height: 50,
                          objectFit: "cover",
                          borderRadius: 4,
                        }}
                      />
                    ) : (
                      <Typography variant="body2" color="textSecondary">
                        No File
                      </Typography>
                    )}
                  </Box>
                </Grid>
              ))}
            </Grid>
          </AccordionDetails>
        </Accordion>
      )}
    </Box>
  );
};

export default ReportSection;
